import {
  AddressSearchResponse,
  Requirements,
  RequirementsPatch,
  UtilityIdentifier,
} from "@Light/services/lightTypes";
import { zip5 } from "@Light/utils/address";

export function addressResponseToRequirementsPatch(
  address: AddressSearchResponse,
): Pick<
  RequirementsPatch,
  "utility" | "service_address" | "utility_account_number"
> {
  return {
    utility: address.utility
      ? { value: address.utility as UtilityIdentifier }
      : undefined,
    service_address: {
      address_1: address.address_1,
      address_2: address.address_2,
      city: address.city,
      state: address.state,
      postal_code: address.postal_code,
    },
    utility_account_number: { value: address.esi_id },
  };
}

/**
 * Makes a requirements patch for updating the service address and utility
 * requirements. Preserves no-op's address if postal code matches, and no-ops
 * utility if it matches. Returns undefined if both are no-ops.
 */
export function utilityAndPostalCodeToRequirementsPatch(
  requirements: Requirements,
  postalCode: string,
  utilityId?: UtilityIdentifier,
): Pick<RequirementsPatch, "service_address" | "utility"> | undefined {
  const patch: Pick<RequirementsPatch, "service_address" | "utility"> = {};
  const existing = requirements.service_address?.value?.postal_code;
  if (!existing || zip5(existing) !== zip5(postalCode)) {
    patch.service_address = {
      address_1: null,
      address_2: null,
      city: null,
      state: null,
      postal_code: postalCode,
    };
  }
  if (utilityId && requirements.utility?.value?.utility?.id !== utilityId) {
    patch.utility = { value: utilityId };
  }
  return Object.keys(patch).length > 0 ? patch : undefined;
}
